export default "__VITE_ASSET__PzKfSVMZ__"